export default __webpack_public_path__ + "static/media/PROPOSAL-FORM.dabd24d7.pdf";